export function getEarliestEffectiveDate(baseDate: Date = new Date(), hour: number | null = null): Date {
  const normalized = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());

  const earliest =
    normalized.getDate() >= 27
      ? new Date(normalized.getFullYear(), normalized.getMonth() + 1, 1)
      : new Date(normalized.getFullYear(), normalized.getMonth(), normalized.getDate() + 1);

  if (hour == null) {
    return earliest;
  }

  return new Date(earliest.getFullYear(), earliest.getMonth(), earliest.getDate(), hour, 0, 0);
}

export function getEarliestEffectiveDateMessage(baseDate: Date = new Date()): string {
  const normalized = new Date(baseDate.getFullYear(), baseDate.getMonth(), baseDate.getDate());
  return normalized.getDate() >= 27
    ? 'The earliest effective date is the first day of next month.'
    : 'The earliest effective date is tomorrow.';
}
